module.exports = __webpack_public_path__ + "static/img/steps_tv2.d9375b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/steps_tv2.png
// module id = 343
// module chunks = 1